import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    width: '100%',
    display: 'flex',
    gap: spacing(16),
    padding: spacing(24, 8, 8),

    '@media (max-width: 900px)': {
      flexDirection: 'column-reverse',
    },
  },
  previewCard: {
    width: '300px',
  },
  checkboxList: {
    display: 'grid',
    gridTemplateColumns: '200px 200px',
    columnGap: spacing(8),
    rowGap: spacing(1),
    alignItems: 'start',
    flex: 1,
    width: '100%',

    '@media (max-width: 900px)': {
      justifyContent: 'space-around',
    },
  },
  previewWrapper: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',

    '@media (max-width: 900px)': {
      justifyContent: 'center',
    },
  },
  errorMessage: {
    fontSize: '12px',
    color: palette.error.main,
    position: 'absolute',
    bottom: '10px',
  },
}))
